import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";

import { Row, Col, FullRow } from "../../framework/Grid/";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link } from "react-router-dom";

class EmailTagDetail extends AcquireWebComponent {
  _downloadTxtFile = (fileName, txt) => {
    var element = document.createElement("a");
    var file = new Blob([txt], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    //element.download = this.props.website_name ? this.props.website_name : this.props.tag_info.siteName
    // 										+ "_Tag_JS.txt"
    element.download = fileName;
    element.click();
  };

  render() {
    const { type } = this.props;
    const { imageTag, deploymentType, id } = this.props.tag_info;

    const filePreName = this.props.campaign_name
      ? this.props.campaign_name
      : this.props.tag_info.campaignName;
    const tagType = deploymentType === "Web" ? "Web Deployment" : "HTML Email";
    const imgTagFileName = (filePreName + "_Tag_IMG.txt").replace(" ", "_");

    return (
      <div
        style={this.props.style ? this.props.style : { padding: "20px 10%" }}
        key="tag-create-confirm"
      >
        <Row className="no-padding no-margin-bottom">
          <Col xs="6" sm="6" lg="6" md="6">
            <a
              className="aa-color"
              onClick={e => {
                this.props.backToListClick(e);
              }}
            >
              Tags
            </a>
            &nbsp;&nbsp;&nbsp;>&nbsp;&nbsp;&nbsp;Insights Tag{" "}
            {type === "detail" ? "Detail" : "Creation"}
          </Col>
          <Col xs="6" sm="6" md="6" lg="6" className="text-right">
            {parseInt(this.props.roleId, 10) === 1 && (
              <Link
                to={"/settings/tags/edit?id=" + id}
                className="btn-aa-default"
              >
                EDIT TAG
              </Link>
            )}
          </Col>
        </Row>
        <div
          className="black-border no-padding mt-20"
          style={{ fontWeight: 300, background: "#FFF" }}
        >
          <FullRow style={{ fontSize: "12pt" }} className="no-padding-bottom">
            <strong>
              INSIGHTS TAG {type === "detail" ? "DETAIL" : "CREATION"}
            </strong>
          </FullRow>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Client Name</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {this.props.clientName}
            </Col>
          </Row>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Business Unit Name</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {this.props.buName}
            </Col>
          </Row>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Tag Deployment Type</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {tagType}
            </Col>
          </Row>
          <Row className="no-padding-top no-padding-bottom ">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Email Campaign Name</strong>
              <span style={{ color: "red" }}>*</span>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {this.props.campaign_name
                ? this.props.campaign_name
                : this.props.tag_info.campaignName}
            </Col>
          </Row>
          <FullRow className="no-padding-top no-padding-bottom ">
            <hr className="black-hr" />
          </FullRow>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Insights Tag ID</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {this.props.tag_info ? this.props.tag_info.uuid : ""}
            </Col>
          </Row>
          <FullRow className="no-padding-top no-padding-bottom mb-20">
            Below is your Insights tracking code for the HTML email campaign you
            specified.
            <br />
            <br />
            If you asked for an Insights tag where you could return a unique
            identifier or to pass hashed emails for matching purposes, the
            primary tag has been <br />
            updated to support your request. <br />
            <br />
            Copy and Paste the Insights tracking code right before the closing
            tag in your HTML, {"</html>"}. <br />
            <br />
            Please note that if you're using a tool to convert your CSS code to
            be inline, it's important to run this tool before you insert our
            tracking code. If you run
            <br />
            it after you've inserted it, the tracking code could be altered and
            prevent you from collecting accurate stats.
          </FullRow>
          <FullRow className="no-padding-top no-padding-bottom mb-20 text-right">
            <button
              type="button"
              className="btn btn-default legitRipple btn-aa-default ml-20"
            >
              <a
                href="https://s3-us-west-2.amazonaws.com/images.audience-anywhere.com/Claritas_Insights_Tag_Implementation_Guide.pdf"
                target="_blank"
              >
                DOWNLOAD IMPLEMENTATION GUIDE
              </a>
            </button>
          </FullRow>
          <FullRow className="no-padding-bottom pl-10 pr-10 pt-10 mb-20 ml-20 mr-20 black-border">
            <FullRow className="no-padding mt-10 mb-10">
              <strong>
                {this.props.campaign_name
                  ? this.props.campaign_name
                  : this.props.tag_info.campaignName}{" "}
                Image Tag
              </strong>
            </FullRow>
            <FullRow className="no-padding">
              <hr className="no-margin" style={{ borderColor: "#000" }} />
            </FullRow>
            <FullRow className="no-padding">
              <span style={{ color: "#F56600" }}>PLEASE NOTE: </span>Image Tags
              require additional parameter configuration. If you are using a Tag
              Manager, please refer to the documentation. For a list of
              available parameters please refer to the Implementation Guide.
            </FullRow>
            <FullRow className="no-padding mb-20">
              <hr className="no-margin" style={{ borderColor: "#000" }} />
            </FullRow>
            <FullRow className="no-padding no-margin-bottom mt-10">
              <textarea
                id="js-code-box"
                value={imageTag}
                readOnly
                style={{
                  width: "100%",
                  height: "60px",
                  border: "none",
                  overflow: "hidden",
                }}
              />
            </FullRow>
            <FullRow className="no-padding no-margin-bottom">
              <hr style={{ borderColor: "#000" }} />
            </FullRow>
            <FullRow className="text-right no-padding mb-20">
              <button
                type="button"
                className="btn btn-default legitRipple btn-aa-default mr-10"
                onClick={e => {
                  e.preventDefault();
                  this._downloadTxtFile(imgTagFileName, imageTag);
                }}
              >
                DOWNLOAD AS TEXT FILE
              </button>
              <CopyToClipboard
                text={imageTag}
                onCopy={() => this.setState({ copied: true })}
              >
                <button
                  type="button"
                  className="btn btn-default legitRipple btn-aa-default"
                >
                  Copy tag to clipboard
                </button>
              </CopyToClipboard>
            </FullRow>
          </FullRow>
          <Row className="no-padding ml-20 mr-20 mb-20 text-right">
            <Col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              className="text-right no-padding"
            >
              <a
                className="aa-color"
                onClick={e => {
                  this.props.backToListClick(e);
                }}
              >
                Back to Tags
              </a>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default EmailTagDetail;



// WEBPACK FOOTER //
// ./src/components/Insights/tags/EmailTagDetail.jsx